import { styled, alpha } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

/** Same color recipe as ProductDrawer StepCardHeader */
export const StepHeaderContainer = styled(Box)<{ accentColor: string }>(
  ({ theme, accentColor }) => ({
    display: 'flex',
    alignItems: 'center',
    margin: `0 ${theme.spacing(2)}`,
    marginBottom: theme.spacing(3),
    padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
    borderRadius: theme.spacing(1),
    transition: 'all 0.3s ease-in-out',
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: alpha(accentColor, theme.palette.mode === 'dark' ? 0.15 : 0.1),
    border: `1px solid ${alpha(accentColor, theme.palette.mode === 'dark' ? 0.3 : 0.2)}`,
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
      borderRadius: theme.spacing(1),
      zIndex: 0,
    },
  }),
);

export const StepHeaderBorder = styled(Box)<{ accentColor: string }>(({ theme, accentColor }) => ({
  width: '8px',
  alignSelf: 'stretch',
  marginRight: theme.spacing(2),
  borderRadius: theme.spacing(0.5),
  backgroundColor: accentColor,
  transition: 'all 0.3s ease-in-out',
  position: 'relative',
  zIndex: 1,
  flexShrink: 0,
}));

export const StepHeaderIcon = styled(Box)<{ accentColor: string }>(({ theme, accentColor }) => ({
  marginRight: theme.spacing(1.5),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: accentColor,
  transition: 'all 0.3s ease-in-out',
  position: 'relative',
  zIndex: 1,
  '& svg': {
    width: 24,
    height: 24,
    transition: 'transform 0.3s ease-in-out',
  },
  '&:hover svg': {
    transform: 'scale(1.1)',
  },
}));

export const StepHeaderTitle = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 600,
  color: theme.palette.text.primary,
  position: 'relative',
  zIndex: 1,
  transition: 'all 0.3s ease-in-out',
}));

export const StepHeaderDescription = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.text.secondary,
  marginTop: theme.spacing(0.5),
  position: 'relative',
  zIndex: 1,
}));
